import {isNullOrUndefined} from 'util';
import {Component, Input} from '@angular/core';

@Component({
    selector: 'tfl-bo-card-box-inline',
    template: `
        <div class="card-box row {{boxColorClass}}" [ngStyle]="getBoxColorStyle()">
            <div class="card-box-header {{ cardBoxHeaderClass }}">
                <ng-content select="tfl-bo-card-box-header"></ng-content>
            </div>
            
            <div class="card-box-content {{ cardBoxContentClass }}">
                <ng-content select="tfl-bo-card-box-content"></ng-content>
            </div>
            
            <div class="card-box-action-inline card-buttons {{ cardBoxActionClass }}">
                <ng-content select="tfl-bo-card-box-action"></ng-content>
            </div>
        </div>
    `,
    styles: ['.btn { margin-bottom: 5px}']
})
export class CardBoxComponentInline {

    @Input('box-color') boxColor: string;
    @Input('box-color-class') boxColorClass: string = '';

    @Input('card-box-header-class') cardBoxHeaderClass: string = 'col-lg-10 col-md-10 col-sm-10 col-xs-12';
    @Input('card-box-content-class') cardBoxContentClass: string = 'col-lg-10 col-md-10 col-sm-10 col-xs-12';
    @Input('card-box-action-class') cardBoxActionClass: string = 'col-lg-1 col-md-2 col-sm-2 col-xs-12';

    getBoxColorStyle(): any {
        if (!isNullOrUndefined(this.boxColor)) {
            return {
                'box-shadow': `-15px 0 0 0 ${this.boxColor}`
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/card-box.inline.component.ts